import { Spinner } from '@chakra-ui/react';

const VSpinner = ({ ...props }) => <Spinner role="status" aria-label="Loading" {...props} />;

export default VSpinner;
